import {
    IChartDatasetOptions as IChartDatasetOptionsBase,
    IChartOptions as IChartOptionsBase,
    IChartSeriesOptions as IChartSeriesOptionsBase
} from './directives/chart';
import { PercentFilter as PercentFilterBase } from './filters/percent-filter';
import { ResultFilter as ResultFilterBase } from './filters/result-filter';

export enum ResultDataType {
    DOLLAR = 'dollar',
    THOUSAND_DOLLAR = 'thousand-dollar',
    MILLION_DOLLAR = 'million-dollar',
    BILLION_DOLLAR = 'billion-dollar',
    PERCENT = 'percent'
}

export { module } from './module';
export { StorageService } from './services/storage-service';

export type PercentFilter = PercentFilterBase;
export type ResultFilter = ResultFilterBase;

export type IChartOptions = IChartOptionsBase;
export type IChartSeriesOptions = IChartSeriesOptionsBase;
export type IChartDatasetOptions = IChartDatasetOptionsBase;
